export interface BCProductVariant {
  variantId: string;
  stacklineSku: string | null;
}

export interface BCProductMetaData {
  stacklineSku: string;
  variations: {
    [variantId: string]: BCProductVariant;
  };
}

/**
 * Retrieves unique Stackline SKUs from window.bcProductMetaData, including the main product and its variations.
 *
 * @returns {string[]} Array of unique SKUs.
 */
export const getStacklineSkus = (): string[] => {
  // Get the product metadata from the window object
  const bcData: BCProductMetaData = (window as any).bcProductMetaData;
  if (!bcData) {
    return [];
  }
  const stacklineSkusSet = new Set<string>();
  if (bcData.stacklineSku) {
    stacklineSkusSet.add(bcData.stacklineSku);
  }
  if (bcData.variations) {
    Object.values(bcData.variations).forEach((variation) => {
      if (variation.stacklineSku) {
        stacklineSkusSet.add(variation.stacklineSku);
      }
    });
  }
  return Array.from(stacklineSkusSet);
};

export const resolveStacklineSkuFromUrlParams = (
  searchURL: string
): {
  dtcVariantId?: string;
  stacklineSku: string | undefined;
} => {
  const queryParams = new URLSearchParams(searchURL);
  const variantId = queryParams.get("variant");
  if (variantId && variantId != "") {
    const stacklineSku =
      (window as any).bcProductMetaData?.variations[variantId]?.stacklineSku ??
      undefined; // ensure we don't return null
    return {
      dtcVariantId: variantId,
      stacklineSku: stacklineSku,
    };
  }
  return { stacklineSku: (window as any).bcProductMetaData?.stacklineSku };
};

export default getStacklineSkus;
